/* Gold-line SVG illustrations for editorial admin empty states.
   All ~120×120, stroke #C9A961 (gold-base), strokeWidth 1, fill none. */
import React from "react";

const PROPS = {
  width: 120, height: 120, viewBox: "0 0 120 120",
  fill: "none", stroke: "var(--gold-base)", strokeWidth: 1,
  strokeLinecap: "round", strokeLinejoin: "round",
};

export function FrameIllustration(props) {
  // Empty picture frame with a tiny corner star.
  return (
    <svg {...PROPS} {...props} aria-hidden="true">
      <rect x="22" y="18" width="76" height="84" />
      <rect x="30" y="26" width="60" height="68" opacity="0.55" />
      {/* Slim hairline cross marks inside */}
      <line x1="30" y1="60" x2="90" y2="60" opacity="0.18" />
      <line x1="60" y1="26" x2="60" y2="94" opacity="0.18" />
      {/* Gold star bottom-right */}
      <path d="M101 91 L102.5 95 L107 95.5 L103.5 98.5 L104.5 103 L101 100.5 L97.5 103 L98.5 98.5 L95 95.5 L99.5 95 Z" fill="var(--gold-base)" opacity="0.9" />
    </svg>
  );
}

export function BookIllustration(props) {
  // Open appointment book with a feather pen.
  return (
    <svg width="140" height="100" viewBox="0 0 140 100" {...PROPS} {...props} aria-hidden="true">
      <path d="M14 22 Q70 12 126 22 V82 Q70 72 14 82 Z" />
      <line x1="70" y1="22" x2="70" y2="82" />
      {/* Ruled lines */}
      {[34,42,50,58,66].map((y) => (
        <React.Fragment key={y}>
          <line x1="22" y1={y} x2="60" y2={y} opacity="0.45" />
          <line x1="80" y1={y} x2="118" y2={y} opacity="0.45" />
        </React.Fragment>
      ))}
      {/* Feather pen */}
      <path d="M120 8 Q132 14 122 28" />
      <line x1="122" y1="28" x2="126" y2="34" />
    </svg>
  );
}

export function StarSigil(props) {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" {...props} aria-hidden="true">
      <path d="M18 4 L20 14 L30 16 L22 22 L24 32 L18 26 L12 32 L14 22 L6 16 L16 14 Z" fill="var(--gold-base)" />
    </svg>
  );
}
